import register from '../../../../global/js/registry';
export default register('m-finder-select-step', () => import(/* webpackMode: "lazy" */ './m-finder-select-step.controller'));
